import { UserPage, UserPageGetResponse } from "@/components/common/model";
import agent from "@/services/agent";
import { defineStore } from "pinia";
import { LoginDTO } from "@/services/models/login";
import authService from "@/services/authService";

export const useUserStore = defineStore({
    id: "user",
    state: () => ({
        userPages: [] as UserPage[],
        userInfo: {} as LoginDTO,
        isFetchingPages: null as Promise<any> | null,
    }),
    actions: {
        setUserPages(userPages: UserPage[]) {
            this.userPages = userPages;
        },
        async fetchUserPages(userId: number) {
            return await agent.get<UserPageGetResponse>(`v1/page/userpage/${userId}`);
        },
        async ensurePagesLoaded(force = false) {
            if (!force && this.userPages.length > 0) return this.userPages;

            // Check cache first if not forcing
            if (!force) {
                const cachedPages = authService.getPages();
                if (cachedPages && cachedPages.length > 0) {
                    this.setUserPages(cachedPages);
                    return cachedPages;
                }
            }

            if (this.isFetchingPages) return this.isFetchingPages;

            const userStr = localStorage.getItem('user');
            if (!userStr) return;

            const user = JSON.parse(userStr);
            if (!user || !user.id) return;

            this.isFetchingPages = (async () => {
                try {
                    const response = await this.fetchUserPages(user.id);
                    if (response && response.result) {
                        this.setUserPages(response.result);
                        authService.setPages(response.result);
                        return response.result;
                    }
                } finally {
                    this.isFetchingPages = null;
                }
            })();

            return this.isFetchingPages;
        },
        setLoggedInUser(userInfo: LoginDTO) {
            this.userInfo = userInfo;
        }
    },
});